export const BoardingTask = {
  path: '/boarding_tasks',
  name: 'boarding_tasks',
  component: () => import('@/views/Boarding/BoardingTask/BoardingTaskPage.vue'),
  children: [

  ],
}